import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form/immutable';
import { push } from 'react-router-redux';

import {
  fetchAccountsRoutine,
  addAccountRoutine,
  upgradeAccountRoutine,
  fetchTaskCountRoutine,
  fetchInvoicesRoutine,
  fetchPaymentSourceRoutine,
  updatePaymentSourceRoutine,
  cancelAccountRoutine,
} from '../routines';
import { setMessage } from '../actions/messages';
import { showError } from '../actions/dialogs';
import { parseApiErrorCode } from '../../utils/helper';
import { getAccountId, getAccountPath } from '../../utils/firebase';
import { post } from '../../utils/request';
import { FIREBASE_CONFIG } from '../../config';
import { buildFilterQuery, fetchSaga, saveSaga } from './helper';

//TODO remove
const getIdToken = () => {

};

function* watchFetchAccounts() {
  yield takeLatest(fetchAccountsRoutine.TRIGGER, fetchSaga(fetchAccountsRoutine, () => '/v1/accounts'));
}

function* watchUpgradeAccount() {
  yield takeLatest(upgradeAccountRoutine.TRIGGER, saveSaga(upgradeAccountRoutine,
    () => getAccountPath('upgrade'),
    () => post,
    ({ token, retentionPeriod, brandedApp }) => ({
      token,
      retentionPeriod,
      brandedApp
    })
  ));
}

function* watchGetTaskCount() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(fetchTaskCountRoutine.TRIGGER, fetchSaga(fetchTaskCountRoutine, (accountId) => `/v1/accounts/${accountId}/taskcount`));
}

function* watchGetPaymentSource() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(fetchPaymentSourceRoutine.TRIGGER, fetchSaga(fetchPaymentSourceRoutine, (accountId) => `/v1/accounts/${accountId}/paymentsource`));
}

function* watchUpdatePaymentSource() {
  yield takeLatest(updatePaymentSourceRoutine.TRIGGER, saveSaga(updatePaymentSourceRoutine,
    () => getAccountPath('paymentsource'),
    () => post,
    (payload) => payload
  ));
}

function* watchFetchInvoices() {
  yield takeLatest(fetchInvoicesRoutine.TRIGGER, fetchSaga(fetchInvoicesRoutine, (payload) => getAccountPath('invoices') + '?' + buildFilterQuery(payload)));
}

function cancelAccount() {
  const accountId = getAccountId();
  return getIdToken().then((idToken) => {
    return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/accounts/${accountId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${idToken}`,
        Accept: 'application/json',
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }

      return res.json().then((err) => {
        throw err;
      });
    });
  });
}

function* cancelAccountSaga(action) {
  try {
    const resp = yield call(cancelAccount, action.payload);
    yield put(cancelAccountRoutine.success(resp));
    yield put(setMessage('login', 'success', 'Your account has been deleted'));
    yield put(push('/logout'));
  } catch (e) {
    console.error('Unable to cancel account', e);
    yield put(showError('Unable to cancel account', e.message || parseApiErrorCode(e.code)));
    yield put(cancelAccountRoutine.failure(new SubmissionError({ error: e.message })));
  }
}

function* watchCancelAccount() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(cancelAccountRoutine.TRIGGER, cancelAccountSaga);
}

// function addAccount(request) {
//   console.log('addAccount', request);
//
//   // create employee
//   const path = '/v1/accounts';
//   return post(path, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     },
//     body: JSON.stringify(request),
//   }, true).then((resp) => {
//     return resp;
//   });
// }
//
// function* addAccountSaga(action) {
//   try {
//     const { values } = action.payload;
//     console.log('values', values.toJS());
//     const account = yield call(addAccount, values.toJS());
//
//     // const account = yield call(resp.json);
//     console.log('account', account);
//
//     yield put(addAccountRoutine.success(account));
//   } catch (e) {
//     console.error('Unable to register', e);
//     yield put(addAccountRoutine.failure(new SubmissionError({ error: e.message })));
//   }
// }

function* watchAddAccountSaga() {
  yield takeEvery(addAccountRoutine.TRIGGER, saveSaga(
    addAccountRoutine,
    () => '/v1/accounts',
    () => post,
    (payload) => payload.values));
}

export {
  watchFetchAccounts,
  watchAddAccountSaga,
  watchUpgradeAccount,
  watchGetTaskCount,
  watchGetPaymentSource,
  watchUpdatePaymentSource,
  watchFetchInvoices,
  watchCancelAccount,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/accounts.js